'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _itemsHash = {};

// Function to attempt to display strings in the user's language, or in
// a the organization's language if not possible
var displayLanguage, orgLanguage; // These get assigned when the component gets the relevant props
function L(obj) {
    return obj[displayLanguage] || obj[orgLanguage] || '';
}

function sum(arr) {
    if (!arr || arr.length == 0) return 0;
    return _lodash2.default.reduce(arr, function (a, b) {
        return a + b;
    });
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

function variationForDisplay(item, idx) {
    var choices;
    if (item.variations[idx].displayType == 'diff') {
        var choiceCounts = {};
        _lodash2.default.forEach(item.variationsChoices[idx], function (choice) {
            choiceCounts[choice.itemId] = choice.count || 1;
        });

        var selectedChoices = _lodash2.default.map(item.variationsChoices[idx], 'itemId');
        var removedChoices = _lodash2.default.difference(item.variations[idx].defaults, selectedChoices);
        var addedChoices = _lodash2.default.difference(selectedChoices, item.variations[idx].defaults);

        choices = _lodash2.default.map(removedChoices.concat(addedChoices), function (choice) {
            var price = (item.variations[idx].prices || {})[choice];
            if (_lodash2.default.isObject(price)) {
                price = price[1];
            }
            return {
                count: choiceCounts[choice] || 0,
                title: L((_itemsHash[choice] || {}).title) || '',
                priceEach: price || 0,
                removedDefault: _lodash2.default.indexOf(removedChoices, choice) != -1
            };
        });
    } else {
        choices = _lodash2.default.map(item.variationsChoices[idx], function (choice) {
            var price = (item.variations[idx].prices || {})[choice.itemId];
            if (_lodash2.default.isObject(price)) {
                price = price[1];
            }
            return {
                count: choice.count || 1,
                title: L(_itemsHash[choice.itemId].title),
                priceEach: price || 0
            };
        });
    }

    return {
        title: L(item.variations[idx].title),
        hidden: item.variations[idx].displayType == 'hidden',
        choices: choices
    };
};

function flattenItem(item) {
    var variations = [];
    var variationsChoices = [];

    function _flattenHelper(variation, arrChoices) {
        variations.push(variation);
        variationsChoices.push(arrChoices);

        _lodash2.default.forEach(arrChoices, function (choice) {
            _lodash2.default.forEach(choice.variations, function (dummy, idx) {
                // Aaaand... recursion!
                _flattenHelper(choice.variations[idx], choice.variationsChoices[idx]);
            });
        });
    }

    _lodash2.default.forEach(item.variations, function (dummy, idx) {
        _flattenHelper(item.variations[idx], item.variationsChoices[idx]);
    });

    item.variations = variations;
    item.variationsChoices = variationsChoices;

    return item;
}

function itemForDisplay(item) {
    item = flattenItem(JSON.parse((0, _stringify2.default)(item)));

    var variations = _lodash2.default.map(item.variations, function (_, idx) {
        return variationForDisplay(item, idx);
    });
    var variationPrices = _lodash2.default.map(variations, function (variation) {
        return sum(_lodash2.default.map(variation.choices, function (choice) {
            return choice.priceEach * choice.count;
        }));
    });

    return {
        title: L((_itemsHash[item.itemId] || {}).title || ''),
        count: item.count || 1,
        priceEach: (item.price || 0) + (sum(variationPrices) || 0),
        variations: variations,
        comment: item.comment
    };
};

function orderForDisplay(orderItems, itemsHash) {
    _itemsHash = itemsHash;

    var items = _lodash2.default.map(orderItems, itemForDisplay);
    return {
        items: items,
        totalPrice: sum(_lodash2.default.map(items, function (item) {
            return item.priceEach * item.count;
        }))
    };
}

// = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

exports.default = {

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    /* TODO - Cancelled so no dependency on React... Yoav.
    propTypes: {
        //orderItems: React.PropTypes.array.isRequired,     // <-- this is required, but can also be accepted as a property of props.order
        itemsHash: React.PropTypes.object.isRequired,
        displayLanguage: React.PropTypes.string.isRequired,
        orgLanguage: React.PropTypes.string.isRequired,
    },
    */

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    getInitialState: function getInitialState() {
        displayLanguage = this.props.displayLanguage;
        orgLanguage = this.props.orgLanguage;

        var orderItems = this.props.orderItems || (this.props.order || {}).orderItems;
        if (orderItems === undefined) {
            console.error('[OrderItemsMixin: getInitialState]', 'OrderItemsMixin called without a list of order items.');
        }

        return {
            orderForDisplay: orderForDisplay(orderItems, this.props.itemsHash)
        };
    },
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var orderItems = nextProps.orderItems || (nextProps.order || {}).orderItems;
        if (orderItems === undefined) {
            console.error('[OrderItemsMixin: componentWillReceiveProps]', 'OrderItemsMixin called without a list of order items.');
        }

        this.setState({
            orderForDisplay: orderForDisplay(orderItems, nextProps.itemsHash)
        });
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/OrderItemsMixin.js
// module id = 1127
// module chunks = 0